export default __webpack_public_path__ + "static/media/earphones1.e391518c.jfif";